import React from 'react';
import cx from 'classnames';
import TransactionDoneError from 'images/transaction_done_error.svg';
import TransactionDoneSuccess from 'images/transaction_done_success.svg';

export enum TransactionResultStatus {
  success,
  rejected,
}

interface TransactionResultMessagePopupProps {
  open: boolean;
  resultStatus?: TransactionResultStatus;
  description?: string;
  buttonText?: string;
  onClose: () => void;
}

// TODO_R: [RP] TransactionResultMessagePopup
// TODO_R: [FRS]
// TODO_R: move into SafeDetailsPage/components
export const TransactionNotification = (props: TransactionResultMessagePopupProps) => {
  const {
    onClose,
    resultStatus = TransactionResultStatus.rejected,
    description,
    buttonText = 'Got it',
  } = props;

  const getTitle = () => {
    if (resultStatus === TransactionResultStatus.success) {
      return 'Success!';
    }

    return 'Rejected';
  };

  const isSuccess = resultStatus === TransactionResultStatus.success;

  return (
    <div className="fixed top-48 left-0 right-0 my-0 mx-auto flex sm:max-w-[595px] px-16 sm:px-24 py-16 items-center justify-between z-50 rounded-[12px] border border-black-4 bg-black-2">
      <div className="flex items-center">
        <div
          className={cx(
            'w-40 h-40 rounded-[20px] flex items-center justify-center mr-16',
            !isSuccess ? 'bg-error-10' : 'bg-success-10'
          )}
        >
          {isSuccess && <img src={TransactionDoneSuccess} alt="" />}
          {!isSuccess && <img src={TransactionDoneError} alt="" />}
        </div>
        <div>
          <div className="text-m16 text-white">{getTitle()}</div>
          <span className="text-r13 text-regular">
            {!isSuccess ? 'Transaction has been rejected' : description}
          </span>
        </div>
      </div>
      <div
        className="flex justify-center items-center w-80 h-48 gap-8 bg-white-10 hover:bg-white-20 cursor-pointer rounded-[6px]"
        onClick={onClose}
      >
        {buttonText}
      </div>
    </div>
  );
};
